import "./FireHazMat.module.css";
import Header from "@/reusable_sections/Header";
import FireHazmat from "./sections/FireHazmat";
import Challenges from "./sections/Challenges";
import ProductShowcase from "./sections/ProductShowcase";
import ResourcesSplit from "./sections/ResourcesSplit";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function FireHazMatPage() {
  return <div>
      <Header />
      <FireHazmat />
      <Challenges />
      <ProductShowcase />
      <ResourcesSplit />
      <Contact />
      <Footer />
    </div>;
}